import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';
import { PlanogramStatus } from './useCreatePlanogramFromProduct';

export interface PlanogramProductResponse {
    id: number;
    name: string;
    image_url: string;
    category_id: number;
    BarCodes: BarCode[];
    planogram?: PlanogramResponseFromProduct[];
    Category: Category;
}

export interface BarCode {
    code: string;
    product_id: number;
}

export interface Category {
    id: number;
    name: string;
}

export interface Store {
    id: number;
    name: string;
    logo: string;
}

export interface PlanogramResponseFromProduct {
    id: number;
    planogram_code: string;
    status: PlanogramStatus;
    standard_amount: number;
    alert_level: number;
    price_list_in_cents: number;
    price_final_in_cents: number;
    stock_amount: number;
    created_at: string;
    updated_at: string;
    due_date: string | null;
    product_id: number;
    store_id: number;
    sales_quantity: number;
    store: Store;
}

export interface PlanogramProductParams {
    productId?: number;
    code?: string;
}

export const useGetPlanogramsByProduct = (params: PlanogramProductParams) => {
    const queryFn = async () => {
        const response = await api.get<PlanogramProductResponse>(
            `/product/planograms-by-product`,
            {
                params: {
                    productId: params.productId,
                    code: params.code,
                },
            },
        );
        return response.data;
    };

    return useQuery({
        queryKey: ['GET_PLANOGRAMS_BY_PRODUCT', params.productId, params.code],
        queryFn,
        refetchOnWindowFocus: false,
        enabled: !!params.productId || !!params.code,
    });
};
